@if (title) {
<p class="s1 col-1">{{ title }}</p>
}

@for (item of items; track $index;) {
<href class="block"
      [hrefClass]="'flex flex-middle'"
      [class.m-t-3]="!$first || title"
      [link]="item.link || ''">
    @if (item.image) {
    <df-image-wrapper class="flex-noshrink m-r-3"
                      style="display: inline-block">
        <img [ratio]="1"
             [width]="52"
             [dfImage]="item.image"
             [alt]="item.label || ''">
    </df-image-wrapper>
    }
    <p class="p2 flex-grow"
       *iCms="'label' of item; content 'html'"></p>
</href>
}